import { Link } from "@tanstack/react-router";
import { FeedbackDialog } from "./feedback-dialog";
import logoSmallUrl from "@/assets/logo-small.svg?url";
import bmcButtonUrl from "@/assets/bmc-button.webp?url";

export function Footer() {
  return (
    <footer className="mt-12 border-t print:hidden">
      <div className="container mx-auto px-4 py-10">
        <div className="grid gap-6 md:gap-12 lg:grid-cols-6">
          <div className="md:col-span-2">
            <Link to="/" className="text-foreground flex items-center gap-2">
              <img
                src={logoSmallUrl}
                alt="Scoopulator Logo"
                width={28}
                height={28}
              />
              <span className="font-semibold tracking-tight">Scoopulator</span>
            </Link>
            <p className="text-muted-foreground mt-3 max-w-68 text-sm">
              A powerful, yet approachable, ice cream calculator for making
              balanced ice cream recipes.
            </p>
            <div className="mt-6 flex flex-col gap-4">
              <div className="flex flex-col items-start gap-1">
                <a
                  href="https://www.buymeacoffee.com/scoopulator"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Support Scoopulator on Buy Me a Coffee"
                >
                  <img
                    src={bmcButtonUrl}
                    alt="Buy Me A Coffee"
                    height={35}
                    width={125}
                  />
                </a>
                <p className="text-muted-foreground mb-2 text-xs">
                  Help keep Scoopulator ad-free
                </p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold">Pages</h3>
            <ul className="text-muted-foreground mt-3 space-y-2 text-sm">
              <li>
                <Link to="/calc" className="hover:text-foreground">
                  Calculator
                </Link>
              </li>
              <li>
                <Link to="/ingredients" className="hover:text-foreground">
                  Ingredients
                </Link>
              </li>
              <li>
                <Link to="/recipes" className="hover:text-foreground">
                  Recipes
                </Link>
              </li>
              <li>
                <Link
                  to="/discover"
                  className="hover:text-foreground flex items-center gap-3"
                >
                  Discover
                </Link>
              </li>
              <li>
                <Link to="/learn" className="hover:text-foreground">
                  Learn
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold">Support</h3>
            <ul className="text-muted-foreground mt-3 space-y-2 text-sm">
              <li>
                <Link
                  to="/changelog"
                  className="hover:text-foreground flex items-center gap-3"
                >
                  What&apos;s new
                </Link>
              </li>
              <li>
                <Link
                  to="/learn/faq"
                  className="hover:text-foreground flex items-center gap-3"
                >
                  FAQ
                </Link>
              </li>
              <li>
                <FeedbackDialog>
                  <button className="hover:text-foreground">
                    Report a bug
                  </button>
                </FeedbackDialog>
              </li>
              <li>
                <FeedbackDialog>
                  <button className="hover:text-foreground">
                    Leave feedback
                  </button>
                </FeedbackDialog>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold">Contact</h3>
            <ul className="text-muted-foreground mt-3 space-y-2 text-sm">
              <li>
                <a
                  href="mailto:hello@scoopulator.app"
                  className="hover:text-foreground"
                >
                  hello@scoopulator.app
                </a>
              </li>
              <li>
                <a
                  href="https://reddit.com/r/scoopulator"
                  className="hover:text-foreground"
                  target="_blank"
                  rel="noreferrer"
                >
                  /r/scoopulator
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold">Legal</h3>
            <ul className="text-muted-foreground mt-3 space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-foreground">
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground">
                  Terms of use
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
